import { render, staticRenderFns } from "./IconThumbsDown.vue?vue&type=template&id=3db7420d"
import script from "./IconThumbsDown.vue?vue&type=script&lang=js"
export * from "./IconThumbsDown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports